import React from 'react'
import './index.css'
import RadioItem from '../RadioItem'
interface ContactItemProps {
    nickname?: string
    avatar?: string
    onSelect?: () => void
    selected?: boolean
}
const ContactItem: React.FC<ContactItemProps> = (props) => {
    return (
        <div className='contact-cell'>
            <RadioItem onSelect={props.onSelect} selected={props.selected}>
                <img className='contact-avatar' src={props.avatar} alt='icon' />
                <span
                    className='single-ell'
                    dangerouslySetInnerHTML={{
                        __html: props.nickname || '',
                    }}
                ></span>
            </RadioItem>
        </div>
    )
}
export default ContactItem
